export function SizeConverter(bytes, decimalPlaces = 2) {
  const parsedBytes = Number(bytes);
  if (isNaN(parsedBytes) || parsedBytes < 0) {
    return '0 B'; // Handle invalid input
  }

  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
  let i = 0;

  let size = parsedBytes;
  while (size >= 1024 && i < sizes.length - 1) {
    size /= 1024;
    i++;
  }

  return `${size.toLocaleString(undefined, { minimumFractionDigits: decimalPlaces, maximumFractionDigits: decimalPlaces })} ${sizes[i]}`;
}
